// src/pages/docs/etc/MagicConch.jsx
import { Typography, Box, Button } from '@mui/material';
import DocsLayout from 'layout/DocsLayout';
import commandList from 'data/commands';
import { useLocation } from 'react-router-dom';
import { getAdjacentCommands } from 'components/getAdjacentCommands';

const MagicCommand = () => {
    const location = useLocation();
    const command = commandList.find((cmd) => cmd.path === location.pathname);
    const { prev, next } = getAdjacentCommands(location.pathname);

    return(
    <DocsLayout>
    <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 4, flexWrap: 'wrap', maxWidth:700 }}>
      {/* 왼쪽 텍스트 영역 */}
      <Box sx={{ flex: 1, minWidth: 260 }}>
        <Typography variant="h4" fontWeight="bold" gutterBottom>
          마법의 전적이님
        </Typography>
        <Typography variant="body1" sx={{ mt: -2, mb: 3 }}>
                    {command?.description ?? '설명이 없습니다.'}
                </Typography>
        <Typography variant="h6">
          {"사용법: 마법의 전적이님 <할말>"}
        </Typography>
        <Typography fontWeight="bold" sx={{ mt: 2 }}>
          <br />
          <span style={{ textDecoration: 'underline' }}>주의</span>
          <br />
          해당 기능은 랜덤으로 대답합니다. 재미로만 사용해 주세요.
        </Typography>
      </Box>

      {/* 오른쪽 이미지 영역 */}
      <Box
        component="img"
        src="/commands/MagicCommand.webp"
        alt="마법의 전적이님"
        sx={{
          width: '100%',
          maxWidth: 300,
          borderRadius: 2,
          flexShrink: 0,
          mx: 'auto',
        }}
      />
      <Box
          sx={{
            display: 'flex',
            justifyContent: { xs: 'center', md: 'space-between' },
            gap: 4,
            width: { xs: '100%',md: 'auto' },
            mt:{md:-12}
          }}
        >
        {prev && (
          <Button href={prev.path} variant="outlined"sx={{height: 36 }}>
            ← {prev.name}
          </Button>
        )}

          <Button variant="outlined"sx={{height: 36, width:118 }}>
            마지막 명령어
          </Button>

        </Box>
    </Box>
  </DocsLayout>
);
};
export default MagicCommand;
